import {Container} from 'react-bootstrap';
import NavigationBar from './HeaderComponents/NavigationBar';

const Header = () =>
    <Container as={'header'} className={'pl-1'}>
        <NavigationBar/>
    </Container>;

export default Header;
